import { Component, OnDestroy, OnInit } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { Subscription } from "rxjs";
import { ApiService } from "src/app/providers/api.service";
import { LoaderServiceService } from "src/app/providers/loader-service.service";
import { NavigationService } from "src/app/providers/navigation.service";
import { CustomConfirmDialogComponent } from "src/app/shared/components/custom-confirm-dialog/custom-confirm-dialog.component";
import { SM_CONSTANTS } from "src/app/shared/constants/sm-constants";

@Component({
  selector: "sm-reward-points",
  templateUrl: "./reward-points.component.html",
  styleUrls: ["./reward-points.component.scss"],
})
export class RewardPointsComponent implements OnInit, OnDestroy {
  constructor(
    private navservice: NavigationService,
    private ns: NavigationService,
    private dialog: MatDialog,
    private apiservice: ApiService,
    private ls: LoaderServiceService,
    private route: ActivatedRoute,
    private _modelRef: MatDialog,
    private router: Router,
  ) {
    this.navservice.hideSidebarAndNav = false;

    this.apisub = this.apiservice.apiResult.subscribe((resdata) => {
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_USER_TOTAL_REWARD_AMOUNT_FOR_ENTITY
      ) {
        if (resdata.result) {
          this.rewardData = {
            total: resdata.result.total_reward ?? 0,
            monthly: resdata.result.current_month_reward_points ?? 0,
          };

          this.apiservice.getUserRewardTransactionsListForEntity(
            this.entityHash,
            this.countrycode,
            this.phone,
            this.pageNo.toString(),
          );
        }
      }
      if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_GET_USER_REWARD_TRANSACTION_LIST_FOR_ENTITY
      ) {
        this.rewardTransactionData = [];
        if (resdata.result) {
          this.rewardTransactionData = resdata.result;
          this.rewardTransactionData.forEach((element: any) => {
            element.tx_status = this.checkRewardStatus(
              element.points_expire_at,
              element.current_status,
            );

            const formatDate = (dateString:any) => {
              const date = new Date(dateString);

              return new Intl.DateTimeFormat("en-US", {
                month: "short",
                day: "2-digit",
                year: "numeric",
              }).format(date);
            };

            element.exp_date = formatDate(element.points_expire_at.slice(0,10))

            element.duty_date = element.created_at;
          });
        }
        this.ls.showLoader = false;
        this.loader = false;
      }
        if (
        resdata.responseType ===
        SM_CONSTANTS.RESULT_API_TRANSFER_REWARDS_TO_WALLET
      ) {
        if (resdata.result) {
          this.apiservice.getUserTotalRewardAmountForEntity(
            this.entityHash,
            this.countrycode,
            this.phone,
          );
            if (resdata.result.errorcode == 0) {
            const dialogRef = this._modelRef.open(
              CustomConfirmDialogComponent,
              {
                data: {
                  title: "Success!",
                  message:
                    "Reward points are successfully transferred to Wallet.",
                  okbtn: "Ok",
                  cancelbtn: "No",
                  type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
                },
                disableClose: true,
              },
            );
          } else {
            const dialogRef = this._modelRef.open(
              CustomConfirmDialogComponent,
              {
                data: {
                  title: "Alert!",
                  message:
                    "Error while transferring reward point to Wallet. Try again.",
                  okbtn: "Ok",
                  cancelbtn: "No",
                  type: SM_CONSTANTS.CUSTOM_DIALOG_ALERT_TYPE,
                },
                disableClose: true,
              },
            );
          }
        }
      }
    });
  }
  entityHash: any;
  eph: any;

  countrycode: any;
  phone: any;
  mn: any;
  me: any;
  apisub: Subscription;
  rewardData: any = {
    total: 0,
    monthly: 0,
    currency_symbol: "",
  };
  loader: boolean = false;
  pageNo: number = 1;
  ngOnInit(): void {
    this.route.queryParams.subscribe((data) => {
      if (data) {
        this.entityHash = data.entityHash;
        this.eph = data.eph;

        this.countrycode = data.code;
        this.phone = data.phone;
        this.mn = data.mn;
        this.me = data.memail;
      }
    });

    this.loader = true;
    this.ls.showLoader = true;
    this.apiservice.getUserTotalRewardAmountForEntity(
      this.entityHash,
      this.countrycode,
      this.phone,
    );
  }
  displayedColumns = ["amt", "duty_date", "type", "notes", "status", "menu"];

  rewardTransactionData: any = [];

  checkRewardStatus(expiryString: any, current_status: any) {
    if (current_status == 2) {
      return "Transferred to wallet";
    }
    // 1. Create date objects
    const expiryDate = new Date(expiryString);
    const today = new Date();

    // 2. Reset time to 00:00:00 to compare "just the date"
    expiryDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);

    // 3. Compare
    if (expiryDate >= today) {
      return "Active";
    } else {
      return "Expired";
    }
  }

  gotoback() {
    this.router.navigate(["../"], {
      relativeTo: this.route,
      queryParamsHandling: "preserve",
    });
  }

  ngOnDestroy(): void {
    this.apisub.unsubscribe();
  }

  transferToWallet() {
    const dialogRef = this._modelRef.open(CustomConfirmDialogComponent, {
      data: {
        title: "Alert",
        message:
          "Are you sure you want to transfer the reward points to wallet?",
        okbtn: "Yes",
        cancelbtn: "No",
        type: SM_CONSTANTS.CUSTOM_DIALOG_CONFIRM_TYPE,
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((data) => {
      if (data) {
        let obj = {
          entity_public_hash: localStorage.getItem(SM_CONSTANTS.CURRENT_ENTITY_PUBLIC_PROFILE_HASH_ID),
          customer_reward_hash:
            this.rewardTransactionData[0].customer_loyalty_reward_hash,
            created_by: localStorage.getItem(
            SM_CONSTANTS.KEY_ACCOUNT_HASH_ID,
          ),
          current_date: this.formatDateString(),
        };

        console.log(obj);

        this.ls.showLoader = true;
        this.apiservice.transferRewardsToWallet(obj);
      }
    });
  }

  formatDateString(): string {
    const now = new Date();

    const options: Intl.DateTimeFormatOptions = {
      timeZone: "Asia/Kolkata",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
      hour: "2-digit",
      minute: "2-digit",
      second: "2-digit",
      hour12: false, // Ensures 24-hour format
    };

    const formattedDate = new Intl.DateTimeFormat(
      "en-CA",
      options,
    ).formatToParts(now);

    let year = "",
      month = "",
      day = "",
      hours = "",
      minutes = "",
      seconds = "";

    formattedDate.forEach((part) => {
      if (part.type === "year") year = part.value;
      if (part.type === "month") month = part.value;
      if (part.type === "day") day = part.value;
      if (part.type === "hour") hours = part.value;
      if (part.type === "minute") minutes = part.value;
      if (part.type === "second") seconds = part.value;
    });

    return `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
  }
}
